module.exports = __webpack_public_path__ + "img/42__239-484-low.8b922cfb.jpg";